import { HttpInterceptorFn, HttpErrorResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { catchError, map, mergeMap, of } from "rxjs";

export const unauthenticatedUserInterceptorFn: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);

    return next(req).pipe(
        catchError((err) => {
            if (err instanceof HttpErrorResponse && err.status === 401) {
                return authService.isAuthenticated$.pipe(mergeMap((isAuthenticated) => {
                    if (isAuthenticated) {
                        return authService.logout().pipe(map(() => {
                            return err;
                        }));
                    }

                    return of(err);
                }));
            }

            return of(err);
        })
    );
}